/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';

//// HAS JS
jQuery(($) => {
  $('html').removeClass('no-js').addClass('js');
});

function isIE() {
  const ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
  const msie = ua.indexOf('MSIE '); // IE 10 or older
  const trident = ua.indexOf('Trident/'); //IE 11

  return (msie > 0 || trident > 0);
}

jQuery(($) => {
  if(isIE()) {
    $('header.banner').after('<div class="ie-warning">This website does not support the browser Internet Explorer. Please use a <a href="https://browser-update.org/nl/update.html?emulate=Mozilla%2F4.0+%28compatible%3B+MSIE+7.0%3B+Windows+NT+10.0%3B+WOW64%3B+Trident%2F8.0%3B+.NET4.0C%3B+.NET4.0E%29" rel="nofollow" target="_blank">modern browser.</a></div>');
  }
});

/**
 * Set target _blank on all external links
 */
jQuery(document).ready($ => {
  $('a[href^="http://"], a[href^="https://"]').not('a[href*="'+location.hostname+'"]').attr('target','_blank');
});

//// SITE FULLY LOADED
window.onload = () =>  {
  jQuery(($) => {
    // Timer just for the fun of it
    setTimeout(() => {
      $('body').addClass('fully-loaded');
      if($('.header-image').length > 0) {
        $('body').addClass('fully-loaded-header');
      }
    }, 200);
  });
};

//// OPEN MENU CLASS IN BODY
function open_menu_click() {
  jQuery(($) => {
    $('.main-menu .navbar-toggler').on('click', ()=> {
      $('body').toggleClass('navigation-open');
    });
  });
}
open_menu_click();

/**
 * Hide Header on on scroll down
 * http://jsfiddle.net/mariusc23/s6mLJ/31/
 */
function hide_header_on_scroll_down() {
  const delta = 1;
  const navbarElement = '#app > header';
  let lastScrollTop = 0;
  let didScroll = false;
  let navbarHeight = jQuery(navbarElement).outerHeight();

  jQuery(($) => {
    document.documentElement.style.setProperty('--menu_inner_height', navbarHeight + 'px');
    window.onresize = () => {
      let navbarHeight = jQuery(navbarElement).outerHeight();
      if(!$('.navbar-collapse').hasClass('show')) {
        document.documentElement.style.setProperty('--menu_inner_height', navbarHeight + 'px');
      }
    }
    $(window).on('scroll', () => {
      didScroll = true;
    });
  });

  setInterval(() => {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);

  function hasScrolled() {
    let st = $('body, html').scrollTop();
    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) {
      return;
    }
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st < 10) {
      $(navbarElement).removeClass('nav-up').removeClass('nav-down');
    } else {
      if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        $(navbarElement).removeClass('nav-down').addClass('nav-up');
        $('.header-news').addClass('scrolled');
        $('.home .header-news').slideUp();
      } else {
        // Scroll Up
        if (st + $(window).height() < $(document).height()) {
          $(navbarElement).removeClass('nav-up').addClass('nav-down');
        }
      }
    }
    lastScrollTop = st;
  }
}
hide_header_on_scroll_down();

/**
 * Open menu on hover
 */
jQuery(($) => {
  let main_menu_name = '#menu-main-menu';
  $('ul' + main_menu_name + ' li.menu-item-has-children').on('mouseenter', (e) => {
    if (window.matchMedia('(pointer:fine)').matches && $(window).width() > 1200) {
      $(e.target).closest('.menu-item-has-children').addClass('hover-item');
    }
  })
  .on('mouseleave', (e) => {
    $(e.target).closest('.menu-item-has-children').removeClass('hover-item');
  })
  .on('click', '> a', (e) => {
    if (window.matchMedia('(pointer:fine)').matches && $(window).width() > 1200) {
      e.preventDefault();
      e.stopPropagation();
      if ($(e.target).closest('.menu-item-has-children').hasClass('hover-item')) {
        $(e.target).closest('.menu-item-has-children').find('ul').addClass('sub-alert');
        setTimeout(() => {
          $(e.target).closest('.menu-item-has-children').find('ul').removeClass('sub-alert');
        }, 200);
      }
    }
  });
});

/**
 * Set timeout for submenu
 */
jQuery(($) => {
  $.each($('header.banner .navbar-nav .dropdown'), ( index, value ) => {
    const min_screen_width = 1201;
    $(value).on('mouseenter', (e) => {
      let screen_witdth = $(window).width();
      if (screen_witdth > min_screen_width) {
        $('header.banner .navbar-nav .dropdown').removeClass('persistant-menu');
        $(e.target).closest('.dropdown').addClass('persistant-menu');
        setTimeout( () => {
          $('header.banner .navbar-nav .dropdown').removeClass('persistant-menu');
        }, 900);
      }
    });
  });
});

/**
 * Add sub-submenu
 */
function add_sub_sub_menu() {
  jQuery(($) => {
    var sub_element = "nav ul > li > ul > li.dropdown > a";
    $(sub_element).attr("data-toggle","dropdown");
    $(sub_element).attr("data-target","#");
    $(sub_element).addClass("dropdown-toggle");
    $(sub_element).closest("li").toggleClass("open");
    $(sub_element).addClass("right-caret");
    $(sub_element).append('<b class="caret right-caret "></b>');
    $(sub_element).on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      $(e.target).closest("li").toggleClass("open");
      $(e.target).attr("aria-expanded","true");
    });

    $(".dropdown-menu > li > a.trigger").on('click', (e) => {
      let this_link = $(e.target).closest('a');
      let current = $(this_link).next();
      let grandparent = $(this_link).parent().parent();
      if($(this_link).hasClass('left-caret')||$(this_link).hasClass('right-caret')) {
        $(this_link).toggleClass('right-caret left-caret');
      }
      grandparent.find('.left-caret').not(this_link).toggleClass('right-caret left-caret');
      grandparent.find('.sub-menu:visible').not(current).hide();
      current.toggle();
      e.stopPropagation();
    });
    $(".dropdown-menu > li > a:not(.trigger)").on('click', (e) => {
      let this_root = $(e.target).closest('.dropdown');
      this_root.find('.left-caret').toggleClass('right-caret left-caret');
      this_root.find('.sub-menu:visible').hide();
    });
  });
}
add_sub_sub_menu();

/**
 * Check height homepage block
 */
function check_homepage_height_block() {
  jQuery(($) => {
    if($('.header-quote-inner').length > 0) {
      let height_quote_text = $('.header-quote-inner').innerHeight();
      let offset_quote_text = $('.header-quote-inner').offset();
      let top_offset_quote_text = offset_quote_text.top;
      let max_height_quote = height_quote_text + top_offset_quote_text + $('.article-image').innerHeight() + 20;
      $('.news-block > .container').removeClass('full-height-quote');
      $('.news-block > .container > article').removeClass('full-height-quote');
      if ($(window).height() < max_height_quote) {
        $('.news-block > .container > article').addClass('full-height-quote');
        $('.news-block > .container').addClass('full-height-quote');
      }
    }
  });
}


jQuery(() => {
  check_homepage_height_block();
  window.onresize = () => {
    check_homepage_height_block();
  }
});


// setTimeout(() => {
//   document.documentElement.style.setProperty('--color_1', '#000000');
//   document.documentElement.style.setProperty('--color_2', '#ffffff');
// }, 5000);

